__turbopack_context__.v({
  "add_to_contacts_button": "styles-module-scss-module__D-0SaG__add_to_contacts_button",
  "agent_card": "styles-module-scss-module__D-0SaG__agent_card",
  "agent_card_content": "styles-module-scss-module__D-0SaG__agent_card_content",
  "agent_card_img": "styles-module-scss-module__D-0SaG__agent_card_img",
  "agent_header": "styles-module-scss-module__D-0SaG__agent_header",
  "agent_header_container": "styles-module-scss-module__D-0SaG__agent_header_container",
  "agent_header_img": "styles-module-scss-module__D-0SaG__agent_header_img",
  "agent_header_outer_container": "styles-module-scss-module__D-0SaG__agent_header_outer_container",
  "agent_header_text": "styles-module-scss-module__D-0SaG__agent_header_text",
  "contact_form": "styles-module-scss-module__D-0SaG__contact_form",
  "copyright_section": "styles-module-scss-module__D-0SaG__copyright_section",
  "designation_item": "styles-module-scss-module__D-0SaG__designation_item",
  "desktop_only": "styles-module-scss-module__D-0SaG__desktop_only",
  "detail_container": "styles-module-scss-module__D-0SaG__detail_container",
  "featured_listings_container": "styles-module-scss-module__D-0SaG__featured_listings_container",
  "form": "styles-module-scss-module__D-0SaG__form",
  "listings_header": "styles-module-scss-module__D-0SaG__listings_header",
  "mobile_only": "styles-module-scss-module__D-0SaG__mobile_only",
  "new_listings_header": "styles-module-scss-module__D-0SaG__new_listings_header",
  "quickbuy_container": "styles-module-scss-module__D-0SaG__quickbuy_container",
  "quickbuy_content": "styles-module-scss-module__D-0SaG__quickbuy_content",
  "quickbuy_content_container": "styles-module-scss-module__D-0SaG__quickbuy_content_container",
  "quickbuy_content_img": "styles-module-scss-module__D-0SaG__quickbuy_content_img",
  "quickbuy_header": "styles-module-scss-module__D-0SaG__quickbuy_header",
  "quickbuy_modal_content": "styles-module-scss-module__D-0SaG__quickbuy_modal_content",
  "register_buttons": "styles-module-scss-module__D-0SaG__register_buttons",
  "register_content": "styles-module-scss-module__D-0SaG__register_content",
  "search_buttons": "styles-module-scss-module__D-0SaG__search_buttons",
  "social_container": "styles-module-scss-module__D-0SaG__social_container",
  "social_link": "styles-module-scss-module__D-0SaG__social_link",
  "testimonial_container": "styles-module-scss-module__D-0SaG__testimonial_container",
  "testimonial_item": "styles-module-scss-module__D-0SaG__testimonial_item",
});
